export const footer = {
  'All rights reserved': '保留所有权利',
  'FooterMoto': '通过开发高效的欺诈检测和预防系统, 减少金融市场中的欺诈行为',
}

export default footer
